export const PermissionCategories = {
    PUT: "mgr-categories-**-PUT",
    POST: "mgr-categories-POST",
    DELETE: "mgr-categories-**-DELETE",
    GET: "mgr-categories-tree-GET",
    GET_UUID: "mgr-categories-**-GET",
    DELETE_IMAGE: "mgr-files-**-DELETE",
    POST_IMAGE: "mgr-files-categories-**-POST",
};